<template>
  <form-wrapper :validator="$v.items">

    <b-row>
      <b-col>
        <b-form-group
          name="zastupca"
          input-cols="11"
          label="">
          <template slot-scope="{ attrs, listeners }">
            <b-form-checkbox
              v-bind="attrs"
              v-model="items.zastupca"
              value="1"
              @change="setNull"
              unchecked-value="0"
              plain
              v-on="listeners">
              {{ $t('message.lgndZastupca') }}
            </b-form-checkbox>
          </template>
        </b-form-group>
      </b-col>
    </b-row>
    <transition
      name="fade"
      mode="out-in">
      <b-row v-if="items.zastupca == true">
        <b-col>
          <text-group
            v-for="(item, key) in textGroupItems.firstGroup"
            :key="key"
            :m="items"
            :align-right="item.alignRight"
            :name="key"
            :label="item.label" />
        </b-col>
        <b-col>
          <text-group
            v-for="(item, key) in textGroupItems.secondGroup"
            :key="key"
            :align-right="item.alignRight"
            :m="items"
            :name="key"
            :label="item.label" />
          <b-form-group
            input-cols="6"
            name="zast_stat"
            :label="$t('message.lblStat')">
            <template slot-scope="{ attrs, listeners }">
              <b-form-select
                class="alignL"
                v-bind="attrs"
                v-model="items.zast_stat"
                :options="$store.state.kraj"
                v-on="listeners">
                <template slot="first">
                  <option :value="null">{{ $t('message.msgSelect') }}</option>
                </template>
              </b-form-select>
            </template>
          </b-form-group>
        </b-col>
      </b-row>
    </transition>

    <b-button
      class="btn-primary"
      @click="save">
      {{ $t('message.lblSave') }}
    </b-button>

  </form-wrapper>
</template>

<script>
import { minLength, maxLength, numeric, required } from 'vuelidate/lib/validators';
import bFormGroup from '@/components/form-group-col4';
import textGroup from '@/components/extractor/textGroup.vue';
import restEditor from '@/mixins/restEditor';
import { containsNumber } from '@/validators';

function zastupcaData() {
  return {
    id: null,
    zastupca: null,
    zast_priezvisko: null,
    zast_meno: null,
    zast_titul: null,
    zast_titul_za: null,
    zast_rc: null,
    zast_ulica: null,
    zast_cislo: null,
    zast_psc: null,
    zast_obec: null,
    zast_stat: null,
  };
}
export default {
  components: {
    bFormGroup, textGroup,
  },

  mixins: [restEditor],

  data() {
    return {
      kraj: [],
      items: zastupcaData(),
      textGroupItems: {
        firstGroup: {
          zast_priezvisko: { label: this.$t('message.lblPriez'), alignRight: false },
          zast_meno: { label: this.$t('message.lblMeno'), alignRight: false },
          zast_titul: { label: this.$t('message.lblTitulP'), alignRight: false },
          zast_titul_za: { label: this.$t('message.lblTitulZ'), alignRight: false },
          zast_rc: { label: this.$t('message.lblRc'), alignRight: false },
        },
        secondGroup: {
          zast_ulica: { label: this.$t('message.lblUlica'), alignRight: false },
          zast_cislo: { label: this.$t('message.lblCislo'), alignRight: false },
          zast_psc: { label: this.$t('message.lblPsc'), alignRight: false },
          zast_obec: { label: this.$t('message.lblObec'), alignRight: false },
        },
      },
    };
  },

  validations: {
    items: {
      zastupca: { required },
      zast_priezvisko: {
        containsNumber, maxLength: maxLength(30),
      },
      zast_meno: {
        containsNumber, maxLength: maxLength(20),
      },
      zast_titul: {
        containsNumber, maxLength: maxLength(10),
      },
      zast_titul_za: {
        containsNumber, maxLength: maxLength(10),
      },
      zast_rc: {
        minLength: minLength(9),
        maxLength: maxLength(11),
      },
      zast_ulica: {
        maxLength: maxLength(28),
      },
      zast_cislo: {
        maxLength: maxLength(20),
      },
      zast_psc: {
        numeric, maxLength: maxLength(5),
      },
      zast_obec: {
        maxLength: maxLength(20),
      },
      zast_stat: { required },
    },
  },

  methods: {
    async processGet() {
      this.items = await this.restDataSource.getData(this.$route.params.userId, 'zastupca');
    },

    async processSave() {
      await this.restDataSource.updateData(this.items, 'zastupca');
    },
    setNull() {
      const element = this.items;

      element.zast_priezvisko = null;
      element.zast_meno = null;
      element.zast_titul = null;
      element.zast_titul_za = null;
      element.zast_rc = null;
      element.zast_ulica = null;
      element.zast_cislo = null;
      element.zast_psc = null;
      element.zast_obec = null;
      element.zast_stat = null;

      this.$v.$reset();
    },
  },
};
</script>
